import ToggleTrashModal from './ToggleTrashModal'
import ToggleTrash from './ToggleTrash'

export {
  ToggleTrash,
  ToggleTrashModal
}
